/* angular:styles/component:css;a1ceb7138d89516f3d9c07b59d22a13600e38fff5459ac0251169117e8a46e3f;/src/src/app/edge/live/Controller/Evse/pages/home.ts */
.oe-modal-buttons-text-size form ion-segment ion-segment-button ion-label {
  white-space: pre-wrap;
  font-size: x-small !important;
}
/*# sourceMappingURL=home.css.map */
